import { Component, Inject } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';
import { AuthenticationService } from '@services/authentication.service';
import { DOCUMENT } from '@angular/common';

/**
 * Default Class Component
 */
@Component({
	selector: 'app-blank',
	templateUrl: './blank.component.html',
	styleUrls: ['./blank.component.scss']
})
export class BlankComponent {

	/**
	 * Default Constructor
	 * @param auth auth
	 * @param authenticationService authenticationService
	 * @param doc doc
	 */
	constructor(
		public auth: AuthService,
		private authenticationService: AuthenticationService,
		@Inject(DOCUMENT) private doc: Document
	) { }

	/**
	 * Logout
	 */
	logout() {
		this.authenticationService.logout(this.doc);
	}

}
